<template>
    <div class="right-panel">
        <div class="wrap">
            <el-input
                v-model="editing_plate.name"
                placeholder="划片名称"
            ></el-input>
            <div v-if="type === 'region'">
                <div
                    v-for="(polygon, i) in editing_plate.region"
                    :key="i"
                    align="center"
                    class="item"
                    :class="{ active: selected_region_layer === i }"
                    @click="selectLayer(i)"
                >
                    <div :span="16">区域{{ i + 1 }}</div>
                    <div :span="8">
                        <el-button
                            type="danger"
                            :disabled="editing"
                            icon="el-icon-delete"
                            circle
                            @click.stop="delRegin(i)"
                        ></el-button>
                    </div>
                </div>
            </div>
            <div v-if="type === 'roads'">
                <div
                    v-for="(polygon, i) in editing_plate.coordinates"
                    @click="selectLayer(i)"
                    :key="i"
                    align="center"
                    class="item"
                    :class="{ active: selected_road_layer === i }"
                >
                    <div :span="16">道路{{ i + 1 }}</div>
                    <div :span="8">
                        <el-button
                            type="danger"
                            icon="el-icon-delete"
                            circle
                            @click.stop="delRoad(i)"
                        ></el-button>
                    </div>
                </div>
            </div>
            <div v-if="type === 'region'" style="margin-top: 24px">
                绘制情况
                <el-switch
                    v-model="editing_plate.region_complete"
                    active-color="#00b08d"
                    inactive-color="#ff4949"
                >
                </el-switch>
            </div>

            <el-row class="bottom">
                <el-button
                    type="success"
                    :disabled="editing"
                    plain
                    @click="submit"
                >确认</el-button>
                <el-button
                    type="success"
                    plain
                    @click="edit"
                >{{
                    editing ? "完成编辑" : "开始编辑"
                }}</el-button>
            </el-row>
        </div>
    </div>
</template>
<script>
import { TYPES } from "@/store/plate_editor";
import { mapState } from "vuex";

import API from "@/service/plate_editor";

export default {
    props: {
        type: String,
    },
    computed: mapState({
        edit_type: (state) => state.PlateEditor.edit_type,
        editing_plate: (state) => state.PlateEditor.editing_plate,
        selected_road_layer: (state) => state.PlateEditor.selected_road_layer,
        selected_region_layer: (state) => state.PlateEditor.selected_region_layer,
    }),
    data() {
        return {
            name: "",
            editing: false,
        };
    },
    methods: {
        selectLayer(i) {
            console.log("selectLayer", i);
            this.$store.dispatch("PlateEditor/selectLayer", i);
        },
        changeTab(tab) {
            this.$store.dispatch("PlateEditor/changeEditType", tab.name);
        },
        async submit() {
            const loading = this.$loading({
                lock: true,
                text: "提交中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            try {
                const { plate_id, plate_facility_id } = this.$route.params;
                console.log("submit", this.editing_plate);
                if (this.type === "region") {
                    await API.updatePlate(plate_id, this.editing_plate);
                } else {
                    await API.updatePlateRoads(
                        plate_id,
                        plate_facility_id,
                        this.editing_plate
                    );
                }
                this.$message({
                    message: "提交成功",
                    type: "success",
                });
            } catch (err) {
                console.error(err);
                this.$message({
                    message: "提交失败, 请稍后重试",
                    type: "error",
                });
            }
            loading.close();
        },
        delRegin(i) {
            this.$store.dispatch("PlateEditor/delRegin", i);
        },
        delRoad(i) {
            this.$store.dispatch("PlateEditor/delRoad", i);
        },
        edit() {
            const action = this.editing
                ? "PlateEditor/finishEditPolygon"
                : "PlateEditor/startEditPolygon";
            this.$store.dispatch(action);
            this.editing = !this.editing;
        },
    },
};
</script>
<style lang="scss" scoped>
.right-panel {
    width: 20%;
    height: 100vh;
    padding: 32px;
    overflow-y: scroll;
    background-color: #fff;
}

.item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px;
    border-bottom: 1px solid #e5e5e5;

    &.active {
        background-color: rgba(255, 80, 80, 0.6);
        color: #fff;
    }
}

.bottom {
    margin-top: 32px;
}
</style>
